import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "m6.912 6.323-.177.177.177.177 4.074 4.074a.52.52 0 0 1-.735.736L6.176 7.412 6 7.235l-.177.177-4.076 4.076-.003.003a.52.52 0 1 1-.736-.735l.003-.003 4.077-4.076.176-.177-.176-.177L1.013 2.25a.52.52 0 0 1 .736-.735l4.074 4.074.177.177.176-.177 4.076-4.076.003-.003a.52.52 0 1 1 .736.735l-.003.003z"
    }, null, -1)
  ]))]))
}
export default { render: render }